module.exports = __webpack_public_path__ + "media/2video.b27d56de.mp4";